import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLeftSmall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-left-small"><path fillRule="evenodd" clipRule="evenodd" d="M13.9092 7.46967C13.6163 7.17678 13.1415 7.17678 12.8486 7.46967L9.90924 10.409C9.03056 11.2877 9.03055 12.7123 9.90924 13.591L12.8486 16.5303C13.1415 16.8232 13.6163 16.8232 13.9092 16.5303C14.2021 16.2374 14.2021 15.7626 13.9092 15.4697L10.9699 12.5303C10.677 12.2374 10.677 11.7626 10.9699 11.4697L13.9092 8.53033C14.2021 8.23744 14.2021 7.76256 13.9092 7.46967Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronLeftSmall;
